import React, { useEffect } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { selectedERFRows } from "../../../../redux/feature/customer_app/customerSlice";
import CustomerConstants from "../../../../common/CustomerConstants";

const CreateERFInvoiceModal = React.forwardRef((props, ref) => {
  const navigate  = useNavigate();
  const dispatch  = useDispatch();

  // props.selectedRows  → array of selected row objects from parent
  // props.modaldata     → { modalTitle, navigate }

  const selectedRows = props?.selectedRows || [];

  const handleSubmit = () => {
    if (selectedRows.length === 0) return;

    // Dispatch the whole array to Redux
    dispatch(selectedERFRows(selectedRows));

    // Close modal, then navigate
    props.onHide();
    navigate(CustomerConstants?.CUSTOMER_V5_MR_ERF_BULCK_INVOICE_CREATION);
  };

  // Escape key closes modal
  useEffect(() => {
    const handleEscapeKey = (e) => {
      if (e.key === "Escape" || e.keyCode === 27) props.onHide();
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => document.removeEventListener("keydown", handleEscapeKey);
  }, [props]);

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="lg"
      ref={ref}
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          <i className="bi bi-plus-lg"></i> {props?.modaldata?.modalTitle}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form className="space-y-4">

          {/* Selected document numbers */}
          <Row>
            <Col xs={12} className="mb-2">
              <p className="fw-bold mb-2">
                Selected ERF Document(s) — {selectedRows.length} record(s)
              </p>
            </Col>
            {selectedRows.map((item, index) => (
              <Col xs={12} sm={6} lg={4} className="me-2 mb-2" key={index}>
                <p className="bg-table-status bg-table-new-status mb-1 px-2">
                  {item?.documentNumber || item?.equipmentRentNr || `Row ${index + 1}`}
                </p>
              </Col>
            ))}
          </Row>

          {selectedRows.length === 0 && (
            <Row>
              <Col xs={12}>
                <p className="errorMsg">* No rows selected. Please select at least one record.</p>
              </Col>
            </Row>
          )}

          {/* Action buttons */}
          <Row className="justify-end mt-3">
            <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
              <button
                type="button"
                onClick={() => props.onHide()}
                className="btn btn-danger mt-4 w-full justify-center rounded-md"
              >
                Cancel
              </button>
            </Col>
            <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
              <button
                type="button"
                onClick={handleSubmit}
                disabled={selectedRows.length === 0}
                className="btn btn-primary mt-4 w-full justify-center rounded-md"
              >
                Proceed to Invoice
              </button>
            </Col>
          </Row>

        </form>
      </Modal.Body>
    </Modal>
  );
});

export default CreateERFInvoiceModal;
